import React from 'react';
import { FormSectionProps, COURSE_TYPES } from './types';

function CourseDetailsSection({ formData, setFormData }: FormSectionProps) {
  return (
    <div className="bg-gray-50 rounded-lg p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Course Details</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Number of Holes
          </label>
          <input
            type="number"
            min="9"
            max="27"
            step="9"
            value={formData.holes || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, holes: e.target.value ? parseInt(e.target.value) : undefined }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="18"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Length (Yards)
          </label>
          <input
            type="number"
            min="1000"
            max="8000"
            value={formData.length_yards || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, length_yards: e.target.value ? parseInt(e.target.value) : undefined }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="6500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Par
          </label>
          <input
            type="number"
            min="27"
            max="80"
            value={formData.par || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, par: e.target.value ? parseInt(e.target.value) : undefined }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="72"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Course Rating
          </label>
          <input
            type="number"
            min="60"
            max="80"
            step="0.1"
            value={formData.course_rating || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, course_rating: e.target.value ? parseFloat(e.target.value) : undefined }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="72.5"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Slope Rating
          </label>
          <input
            type="number"
            min="55"
            max="155"
            value={formData.slope_rating || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, slope_rating: e.target.value ? parseInt(e.target.value) : undefined }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
            placeholder="125"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Course Type
          </label>
          <select
            value={formData.course_type || ''}
            onChange={(e) => setFormData(prev => ({ ...prev, course_type: e.target.value }))}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
          >
            <option value="">Select course type</option>
            {COURSE_TYPES.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>
      </div>

      <div className="mb-6">
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            id="is_public"
            checked={formData.is_public || false}
            onChange={(e) => setFormData(prev => ({ ...prev, is_public: e.target.checked }))}
            className="rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
          />
          <label htmlFor="is_public" className="text-sm font-medium text-gray-700">
            Public Course (Open to general public)
          </label>
        </div>
      </div>
    </div>
  );
}

export default CourseDetailsSection;